import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Modal } from "../components/Modal";
import { getActionBySlug } from "../services/admin/actions";
import App from "../App";
import AppLoading from "./AppLoading";

export default function ModalWrapper() {
	const { action: slug } = useParams();
	const navigate = useNavigate();
	const [actionData, setActionData] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		async function loadAction() {
			if (!slug) {
				navigate("/");
				return;
			}

			try {
				const data = await getActionBySlug(slug);

				if (!data) {
					navigate("/");
					return;
				}

				setActionData(data);
			} catch (error) {
				console.error("Erro ao buscar ação:", error);
				navigate("/");
			} finally {
				setLoading(false);
			}
		}

		loadAction();
	}, [slug, navigate]);

	const handleClose = () => navigate("/");

	if (loading) return <AppLoading />;

	return (
		<>
			<App />
			{actionData && (
				<Modal action={actionData} isOpen={true} onClose={handleClose} />
			)}
		</>
	);
}
